import { ProductTypeName } from '@electricjs/core_entity-client';
import { COUNTRIES } from '@electricjs/arc';

// limited to US and CA only (products from TD Synnex only)
export const CATALOG_AVAILABLE_COUNTRIES = [COUNTRIES.US, COUNTRIES.CA];

/** List of ProductTypes that are only related to hardware (that are managed in the catalog) */
export const HARDWARE_PRODUCT_TYPES: ProductTypeName[] = [
  ProductTypeName.Laptop,
  ProductTypeName.Desktop,
  ProductTypeName.Mouse,
  ProductTypeName.Keyboard,
  ProductTypeName.KeyboardMouse,
  ProductTypeName.Monitor,
  ProductTypeName.Dock,
  ProductTypeName.Audio,
  ProductTypeName.Video,
  ProductTypeName.Warranty,
  ProductTypeName.Miscellaneous,
  ProductTypeName.CellPhone,
  ProductTypeName.OtherPhone,
  ProductTypeName.Tablets,
  ProductTypeName.Headphones,
  ProductTypeName.Microphone,
  ProductTypeName.PowerAdapter,
  ProductTypeName.Cable,
  ProductTypeName.Accessory,
];
